/**
 * Umbrales de las etiquetas de la tabla de servicios, de la ocupación y del aviso general de más de una hora de espera.
 * Ya no se editan en pantalla: para cambiar una regla se cambia el valor acá. Las causas de «Dónde hay más espera» y el
 * nivel de cada servicio (que también usa la tabla) no están acá: los calcula el backend.
 */

/** Sobreturnos máximos de una agenda, en % de sus atenciones. */
export const ALERT_MAX_OVERBOOKED_PERCENT = 25;
/** Ocupación mínima de una agenda, en %. */
export const ALERT_MIN_OCCUPANCY_PERCENT = 40;
/**
 * Baja asistencia (reemplaza a «Ocupación baja»): los ausentes son al menos este % de los turnos reservados
 * (agendados, atendidos y ausentes). Espeja la regla del backend.
 */
export const ALERT_LOW_ATTENDANCE_MISSED_PERCENT = 50;

/** Un servicio necesita al menos esta cantidad de atenciones para que se lo marque en la tabla. */
export const ALERT_MIN_ATTENTIONS = 30;
/** Una agenda necesita al menos esta cantidad de lugares ofrecidos para que se la marque por ocupación. */
export const ALERT_MIN_SLOTS = 20;
/** Proporción de atenciones con más de una hora de espera que dispara el aviso general. */
export const ALERT_WAIT_60_THRESHOLD_RATIO = 0.05;

/**
 * Turnos más cortos que la consulta: la duración media real de una agenda de consultorio tiene que ser al menos este
 * múltiplo del turno programado (1,1 = un 10 % más larga).
 */
export const ALERT_SHORT_SLOT_RATIO = 1.1;
/** El turno que se sugiere es la duración media redondeada hacia arriba a un múltiplo de estos minutos. */
export const SLOT_ROUNDING_MINUTES = 5;

/**
 * Se pasa del horario: una agenda de consultorio se pasa del horario si en al menos esta cantidad de jornadas se terminó
 * de atender después del cierre de la agenda, y esas jornadas son al menos esta fracción de las jornadas con atenciones
 * (0,25 = 25 %). El backend ya descuenta la tolerancia (solo cuenta si se terminó más de 5 min después del cierre).
 */
export const ALERT_MIN_OVERRUN_DAYS = 3;
export const ALERT_MIN_OVERRUN_SHARE = 0.25;
/** El exceso medio de estos minutos o más hace que la alerta sea de nivel alto; por debajo, media. */
export const ALERT_HIGH_OVERRUN_MINUTES = 30;

/** Cuántas filas muestra «Dónde hay más espera» (el resto de los avisos está en «Ver los N avisos»). */
export const WAIT_RANKING_ROWS = 5;

/** Mínimo de atenciones del período anterior para mostrar la variación de la espera de un servicio en la tabla. */
export const MIN_PREVIOUS_FOR_WAIT_CHANGE = 10;

/** Nivel de un servicio o agenda («En regla», «Atención», «Crítica»): lo calcula el backend en el ranking de espera. */
export type WaitLevel = 'ok' | 'warn' | 'err';

/** El aviso general de espera de más de una hora aparece desde esta fracción de las atenciones; no lleva nivel. */
export const hasWait60Notice = (ratio: number): boolean => ratio >= ALERT_WAIT_60_THRESHOLD_RATIO;

/** Un día de la semana y hora necesita al menos esta cantidad de atenciones para entrar en "Peores horarios". */
export const CRITICAL_HOURS_MIN_ATTENTIONS = 10;
/** Cuántas horas con más espera se toman antes de unir las que son seguidas del mismo día. */
export const CRITICAL_HOURS_CANDIDATES = 6;
/** Cuántos horarios se nombran en la frase de "Peores horarios". */
export const CRITICAL_HOURS_MAX_SHOWN = 3;
